import { Injectable } from '@angular/core';
import { Router, CanActivate, CanActivateChild, ActivatedRouteSnapshot,
         RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

import {AuthService} from '@app/service/auth.service';

@Injectable()
//  providedIn: 'root'

class AuthGuard 
      implements CanActivate, CanActivateChild 
{
    constructor
    (
        private router: Router,
        private authService: AuthService
    )
    {
        
    }
    
    canActivate
    (
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean | UrlTree> | 
        Promise<boolean | UrlTree> | boolean | UrlTree 
    {
        let currentUser;
        let result: boolean;
        let requiresVerification: boolean;
        let isLogoutInProgress: boolean;

        currentUser =
            this.authService.userValue;
        result = false;
        requiresVerification = false;
        isLogoutInProgress = false;

        if (currentUser)
        {
            isLogoutInProgress =
                this.authService.isLogoutInProgress();
            requiresVerification =
                this.authService.requiresVerification();
            if (isLogoutInProgress)
            {
                result = true;
            }
            else if (requiresVerification)
            {
                this.router.navigate(['/login/verify']);
                result = false;
            }
            else
            {
                result = true;
            }
        }
        else
        {
            this.router.navigate([`login`]);
            result = false;
        }

        return result;
    }
    
    canActivateChild
    (
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean | UrlTree> |
       Promise<boolean | UrlTree> |
       boolean | UrlTree
    {
        let returnUrl;
        let accessKey;
        let username;
        let currentUser;
        let targetUrl;
        let result;
        let requiresVerification: boolean;
        let isLogoutInProgress: boolean;

        returnUrl =
            next.queryParams['returnUrl'] || '';
        accessKey =
            next.queryParams['accessKey'] || '';
        username =
            next.queryParams['username'] || '';

        currentUser =
            this.authService.userValue;
        result = false;
        requiresVerification = false;
        isLogoutInProgress = false;

        if (currentUser)
        {
            targetUrl = state.url;
            isLogoutInProgress =
                this.authService.isLogoutInProgress();
            requiresVerification =
                this.authService.requiresVerification();

            if (isLogoutInProgress)
            {
                result = true;
            }
            else if (requiresVerification &&
                !targetUrl.startsWith('/login/verify'))
            {
                this.router.navigate(['/login/verify']);
                result = false;
            }
            else if (currentUser.mustChangePassword &&
                !targetUrl.startsWith('/settings'))
            {
                this.router.navigate(
                    ['/settings']
                );

                result = false;
            }
            else
            {
                result = true;
            }
        }
        else if (
            returnUrl && accessKey && username)
        {
            this.router.navigate(
                ['/login'],
                {
                    queryParams:
                    {
                        returnUrl: returnUrl,
                        accessKey: accessKey,
                        username: username
                    }
                }
            );
            result = false;
        }
        else
        {
            this.router.navigate([`login`]);
            result = false;
        }

        return result;
    }  
}

export { AuthGuard }
